import React from 'react';
import { Form, Col, Row, Button } from "antd";
import PropTypes from "prop-types";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import  { RISK_CONTROLS_FORM }  from "constants/form-fields";
import { MpaFormsFooter } from '../../modules/companies/modules/mpa-form-footer';
import { INPUT_TYPES } from "constants/input-types";
import { RECOURSE_STRUCTURE } from '../../constants';

class RiskControlForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);


    saveDraft = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.updateDetail(values);
            }
        });
    }

    onApprove = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.approveDetails()
            }
        });
    }

    handleFieldValueChange = (fieldName, value) => {
        if(fieldName == "security_type" && value == 5){
            this.props.form.setFieldsValue({
                security_perc: null,
                security_amount: null,
            })
        }

        if (fieldName == "holdback_calculation_type") {
            this.props.form.setFieldsValue({
                security_perc: null,
                security_amount: null,
            })
        }

        if (fieldName == 'is_churns_applicable') {
            this.props.form.setFieldsValue({
                number_of_churns: null,
                pre_churn_db_security_perc: null,
                post_churn_db_security_perc: null
            })
        }
        if (fieldName == 'recourse_structure') {
            if(value == 1){
                this.props.form.setFieldsValue({
                    is_churns_applicable: false,
                    recourse_perc: null,
                })
            }else if(value == 2){
                this.props.form.setFieldsValue({
                    is_churns_applicable: true,
                    recourse_perc: null,
                })
            }else if(value == 3){
                this.props.form.setFieldsValue({
                    recourse_perc: null,
                })
            }else if(value == 4){
                this.props.form.setFieldsValue({
                    recourse_perc: null,
                })
            }else if(value == 5){
                this.props.form.setFieldsValue({
                    is_churns_applicable: false,
                    recourse_perc: 100
                })
            }
        }
        if(fieldName == 'recourse_perc' && this.props.form.getFieldValue('recourse_structure') === 4){
            this.props.form.setFieldsValue({
                pre_churn_db_security_perc: null,
                // post_churn_db_security_perc: value
            })
        }
    }

    renderForm = () => {
        return RISK_CONTROLS_FORM.map((field, fieldName) => {
            // field.disabled = this.props.disableFields;
            const recourse_structure = this.props.form.getFieldValue("recourse_structure");
            const recourse_perc_value = this.props.form.getFieldValue("recourse_perc");
            if(!this.props.disableFields){
                if (fieldName == "security_perc") {
                    const holdback_calculation_type = this.props.form.getFieldValue("holdback_calculation_type");
                    const security_type = this.props.form.getFieldValue("security_type");
                    if (holdback_calculation_type == 2) {
                        field.disabled = false;
                        field.rules = [
                            {
                                required: true,
                                message: "Field is Required"
                            },
                            {
                                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                message: "Input must be between 0 and 100"
                            }
                        ];
                    } else {
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
                    }
                    if (security_type == 5) {
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
                    }
                }
                if (fieldName == "security_amount") {
                    const holdback_calculation_type = this.props.form.getFieldValue("holdback_calculation_type");
                    const security_type = this.props.form.getFieldValue("security_type");
    
                    if (holdback_calculation_type == 2) {
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
                    } else {
                        field.disabled = false;
                        field.rules = [
                            {
                                required: true,
                                message: "Field is Required"
                            },{
                                pattern: /^(?:\d*\.)?\d+$/,
                                message: "Please enter a valid number"
                            }
                        ];
                    }
                    if (security_type == 5) {
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
                    }
                }
                
                if (fieldName == "holdback_calculation_type") {
                    const security_type = this.props.form.getFieldValue("security_type");
                    if (security_type == 5) {
                        field.disabled = true;
                    }
                }
                if(['number_of_churns'].includes(fieldName)){
                    const is_churns_applicable = this.props.form.getFieldValue("is_churns_applicable");
                    if (is_churns_applicable) {
                        field.disabled = false;
                        field.rules = [
                            {
                                required: true,
                                message: "Field is Required"
                            },
                            {
                                pattern: /^(?:\d*\.)?\d+$/,
                                message: "Please enter a valid number"
                            }
                        ];
                    } else{
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
    
                    }
                }
                if (['pre_churn_db_security_perc', 'post_churn_db_security_perc'].includes(fieldName)) {
                    const is_churns_applicable = this.props.form.getFieldValue("is_churns_applicable");
                    if (is_churns_applicable) {
                        field.disabled = false;
                        field.rules = [
                            {
                                required: true,
                                message: "Field is Required"
                            },
                            {
                                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                message: "Input must be between 0 and 100"
                            }
                        ];
                    } else{
                        field.disabled = true;
                        field.rules = [{
                            required: false
                        }];
                    }
                }
                if (fieldName === "recourse_perc") {
                    const recourse_structure = this.props.form.getFieldValue("recourse_structure");
                    field.type = INPUT_TYPES.NUMBER; 
                    field.disabled = false;
                    field.rules = [
                        {
                            required: true,
                            message: "Field is required"
                        },
                        {
                            pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                            message: "Input must be between 0 and 100"
                        }
                    ];
                    if (recourse_structure == 3) {
                        field.disabled = true;
                        field.rules = [{ required: false }];
                    }
                    if (recourse_structure == RECOURSE_STRUCTURE.get('50-50 Risk Sharing')) {
                        field.type = INPUT_TYPES.SELECT;
                        field.options = Array.from({ length: 10 }, (_, i) => ({
                            label: `${(i + 1) * 10}`,
                            value: (i + 1) * 10
                        }));
                        // field.value = recourse_perc_value || (field.options && field.options[0]?.value);
                    }
                }
                if(fieldName == 'effective_date'){
                    const recourse_structure = this.props.form.getFieldValue("recourse_structure");
                    if(recourse_structure == RECOURSE_STRUCTURE.get('100-0 Risk Sharing')){
                        field.disabled = false;   
                    }else{
                        field.disabled = true;   
                    }
                }
                if (fieldName === "pre_churn_db_security_perc") {
                    field.type = INPUT_TYPES.INPUT;
                    field.options = undefined;
                    if([RECOURSE_STRUCTURE.get('100-0 Risk Sharing'), RECOURSE_STRUCTURE.get('50-50 Risk Sharing')].includes(recourse_structure)) {
                        field.type = INPUT_TYPES.SELECT;
                        const startValue = Math.ceil((recourse_perc_value + 1) / 10) * 10;
                        if (recourse_perc_value) {
                            field.options = Array.from({ length: (100 - startValue) / 10 + 1 }, (_, i) => ({
                                label: (startValue + (i * 10)).toString(),
                                value: startValue + (i * 10)
                            }));
                        } else {
                            field.options = [];
                        }
                    }
                }
                if (fieldName === "post_churn_db_security_perc") {
                    if ([RECOURSE_STRUCTURE.get('100-0 Risk Sharing'), RECOURSE_STRUCTURE.get('50-50 Risk Sharing')].includes(recourse_structure)) {
                        return false;
                    }
                }
                // if (fieldName === "post_churn_db_security_perc") {
                //     if (recourse_structure === 4) {
                //         field.disabled = true; 
                //         // this.props.form.setFieldsValue({
                //         //     post_churn_db_security_perc: this.props.form.getFieldValue('recourse_perc')
                //         // });
                //     } else {
                //         field.disabled = false;
                //     }
                // }
            }
            const value = this.props.values && this.props.values[fieldName];
            return <Col span={field.col}>{this.fieldGenerator(
                fieldName,
                { ...field, value },
                this.getValidateStatus(fieldName),
                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e :  e.target.value)),
                true
            )()}</Col>;
        }).toList();
    }

    renderFooter = () => {
        return <MpaFormsFooter 
            disableFields = {this.props.disableFields}
            approveDisabled={this.props.approveDisabled}
            onApprove={this.onApprove}
        />
        
    }


    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Form onSubmit={this.saveDraft}>
                    <Row>
                        {this.renderForm()}
                    </Row>
                    {this.renderFooter()}
                </Form>
            </div>
        );
    }
}

RiskControlForm.propTypes = {
    mpa_approval_data: PropTypes.object,
    updateDetail: PropTypes.func,
    approveDetails: PropTypes.func,
    approveDisabled: PropTypes.bool,
    disableFields: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    if (["security_type", "holdback_calculation_type"].includes(key) && [null, "" , 0].includes(value)) {
                        return Form.createFormField({
                            value: 1
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(RiskControlForm);